


























import { Vue, Component } from "vue-property-decorator";

import TitleBar from "../components/TitleBar.vue";
import CardComponent from "../components/CardComponent.vue";
import AppAuthorizationsTable from "../components/AppAuthorizationsTable.vue";
import {
  deleteAppAuthorization,
  getAppAuthorizations,
} from "../api/app-authorizations";
import { AppAuthorization } from "../api/types";

@Component({
  name: "app-authorizations",

  components: {
    CardComponent,
    AppAuthorizationsTable,
    TitleBar,
  },
})
export default class ThirdPartyApps extends Vue {
  authorizations: AppAuthorization[] = [];
  loading = false;

  get titleStack() {
    return ["Third-Party Apps"];
  }

  mounted() {
    this.loadAuthorizations();
  }

  refresh() {
    this.loadAuthorizations();
  }

  loadAuthorizations() {
    this.loading = true;
    getAppAuthorizations()
      .then(({ data }) => {
        this.authorizations = data;
        this.loading = false;
      })
      .catch((error) => {
        this.authorizations = [];
        this.loading = false;
        throw error;
      });
  }

  onDeleteAuthorization(tokenId: number) {
    this.loading = true;
    deleteAppAuthorization(tokenId)
      .then(() => {
        return this.loadAuthorizations();
        this.loading = false;
      })
      .catch((error) => {
        this.authorizations = [];
        this.loading = false;
        throw error;
      });
  }
}
